import { useEffect, useRef, useState } from 'react';

let modalStackSeq = 0;
const modalStackOrders = new Map();

/**
 * Stack global de modales para mantener z-index consistente.
 * Regla:
 * - Backdrop base: 900
 * - Modal base: 1000
 * - Cada modal adicional sube +100
 */
export function useModalStackLayer(isOpen) {
  const idRef = useRef(null);
  if (idRef.current == null) {
    idRef.current = `modal-layer-${Math.random().toString(36).slice(2, 10)}`;
  }

  const [order, setOrder] = useState(1);

  useEffect(() => {
    const id = idRef.current;
    if (!isOpen) {
      modalStackOrders.delete(id);
      return;
    }

    modalStackSeq += 1;
    modalStackOrders.set(id, modalStackSeq);
    setOrder(modalStackSeq);

    return () => {
      modalStackOrders.delete(id);
    };
  }, [isOpen]);

  const modalZ = 900 + order * 100; // 1000, 1100, 1200...
  const backdropZ = 800 + order * 100; // 900, 1000, 1100...

  return {
    layerOrder: order,
    backdropZ,
    modalZ,
  };
}
